export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";

export const SUBMIT_PLANNING_EVALUATION = "SUBMIT_PLANNING_EVALUATION";
export const SUBMIT_PLANNING_EVALUATION_SUCCESS = "SUBMIT_PLANNING_EVALUATION_SUCCESS";
export const SUBMIT_PLANNING_EVALUATION_ERROR = "SUBMIT_PLANNING_EVALUATION_ERROR";

export const SET_PLANNING_EVALUATION_DATA = "SET_PLANNING_EVALUATION_DATA";
export const CLEAR_PLANNING_EVALUATION_DATA = "CLEAR_PLANNING_EVALUATION_DATA";

export const FETCH_PLANNING_EVALUATION_STATUSES = "FETCH_PLANNING_EVALUATION_STATUSES";
export const FETCH_PLANNING_EVALUATION_STATUSES_SUCCESS = "FETCH_PLANNING_EVALUATION_STATUSES_SUCCESS";
export const FETCH_PLANNING_EVALUATION_STATUSES_ERROR = "FETCH_PLANNING_EVALUATION_STATUSES_ERROR";

export const RESET_PLANNING_EVALUATION_SUBMISISON =
  "RESET_PLANNING_EVALUATION_SUBMISISON";

export const OPEN_PLANNING_EVALUATION_TABLE_MODAL =
  "OPEN_PLANNING_EVALUATION_TABLE_MODAL";
export const CLOSE_PLANNING_EVALUATION_TABLE_MODAL = "CLOSE_PLANNING_EVALUATION_TABLE_MODAL";

export const SHOW_PLANNING_EVALUATION_DETAILS = "SHOW_PLANNING_EVALUATION_DETAILS";
export const HIDE_PLANNING_EVALUATION_DETAILS = "HIDE_PLANNING_EVALUATION_DETAILS";
